import { MetaApi } from '../api/MetaApi'

export const seo = {

	metaInfo () {
		return {
			title: this.title,
			// override the parent template and just use the above title only
			titleTemplate: null,
			meta: [
				{
					'property': 'og:site_name',
					'content': 'Quomi'
				},
				{
					'property': 'og:title',
					'content': this.title
				},
				{
					'property': 'og:image',
					'content': this.image
				},
				{
					'property': 'og:url',
					'content': window.location.href
				},
				{
					'property': 'twitter:image',
					'content': this.image
				},
				{
					'name': 'twitter:title',
					'content': this.title
				},
				{
					'name': 'description',
					'property': 'og:description',
					'content': this.description
				},
				{
					'name': 'twitter:description',
					'content': this.description
				},
				{
					'name': 'robots',
					'content': this.robots
				}
			],
			// link: [
			// 	{
			// 		rel: 'canonical',
			// 		href: this.canonical
			// 	}
			// ]
		}
	},

	data () {
		return {
			title: '',
			description: '',
			robots: '',
			// canonical: '',
			image: ''
		}
	},

	watch: {
		'$route' () {
			this.$_seo_initial()
			this.$_seo_meta()
		}
	},

	methods: {
		$_seo_meta () {
			var path = window.location.pathname
			var lastPart = path.substring(1)

			var api = new MetaApi()
			var param = lastPart

			if (process.env.NODE_ENV === 'development') return

			api.get(param).then(response => {
				if (response.body.data.resource.title) this.title = response.body.data.resource.title
				if (response.body.data.resource.description) this.description = response.body.data.resource.description
				if (response.body.data.resource.robots) this.robots = response.body.data.resource.robots
				// if (response.body.data.resource.canonical) this.canonical = response.body.data.resource.canonical
				if (response.body.data.resource.image) this.image = response.body.data.resource.image
			}).catch(response => {

			})
		},

		$_seo_initial () {
			this.title = 'Le tue cene a casa, senza pensieri | Quomi'
			this.description = 'Ingredienti freschi per ricette stagionali semplici da cucinare spediti a casa tua ogni settimana. Per preparare le tue cene senza pensieri insieme a Quomi'
			this.robots = ''
			// this.canonical = location.protocol+'//'+location.host + window.location.pathname
			this.image = '/static/cover-box.jpg'
		
		}
	},

	mounted () {
		this.$_seo_initial()
		this.$_seo_meta()
	}
}
